<template>
  <div class="slider__fragments">
    <vueper-slides
      autoplay
      :fixed-height="true"
      class="no-shadow"
      :visible-slides="1"
      slide-multiple
      :arrows-outside="false"
      :bullets="false"
      :infinite="true"
      :dragging-distance="100"
      :touchable="true"
      :disable-arrows-on-edges="true"
      :breakpoints="{ 800: { visibleSlides: 1, } }"
    >
      <template #arrow-left>
        <img src="@/assets/images/icons/prev.png">
      </template>

      <template #arrow-right>
        <img src="@/assets/images/icons/next.png">
      </template>
      <vueper-slide
        v-for="(slide, i) in slides"
        :key="i"
        :image="slide.image"
      >
        <template #content>
          <div>
          </div>
        </template>
      </vueper-slide>
    </vueper-slides>
  </div>
</template>

<script>
import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";

export default {
  name: "SliderFragments",
  data() {
    return {
      title: "Slider",
       slides: [
        {
          image: require("@/assets/images/slider_frag/erbel.jpg"),
  
        },
        {
          image: require("@/assets/images/slider_frag/kramarz.jpg"),
        },
        {
          image: require("@/assets/images/slider_frag/parfianowicz.jpg"),
        },
        {
          image: require("@/assets/images/slider_frag/rok.jpg"),
        },
          {
          image: require("@/assets/images/slider_frag/sawicki.jpg"),
  
        },
        {
          image: require("@/assets/images/slider_frag/staszewski.jpg"),
        },
        {
          image: require("@/assets/images/slider_frag/velez.jpg"),
        },
        {
          image: require("@/assets/images/slider_frag/zygmuntowski.jpg"),
        },
      ]
    };
  },
  components: { VueperSlides, VueperSlide },
};
</script>
